import { api, errorFn } from "@/common/apiService";
import {
  CREATE_MERCHANT,
  FETCH_MERCHANTS,
  FETCH_MERCHANT,
  UPDATE_MERCHANT,
  DELETE_MERCHANT,
  CREATE_MERCHANT_LOCATION,
  FETCH_MERCHANT_LOCATIONS,
  FETCH_MERCHANT_LOCATION,
  UPDATE_MERCHANT_LOCATION,
  DELETE_MERCHANT_LOCATION,
  SCHEDULE_VISIT,
  CREATE_TERMINAL,
  FETCH_TERMINALS,
  FETCH_TERMINAL,
  UPDATE_TERMINAL,
  DELETE_TERMINAL,
} from '../actions/merchant';

const state = {
  merchant: {},
  merchants: [],
  merchantsCount: 0,
  merchantLocation: {},
  merchantLocations: [],
  merchantLocationsCount: 0,
  terminal: {},
  terminals: [],
  terminalsCount: 0
}

const getters = {
  getMerchantById: (state) => (id) => {
    return state.merchants.find(merchants => merchants.id == id)
  },
  getMerchantLocationById: (state) => (id) => {
    return state.merchantLocations.find(location => location.id == id)
  }
}

const mutations = {
  [FETCH_MERCHANTS]: (state, merchantsData) => {
    state.merchants = [...merchantsData.results]
    state.merchantsCount = merchantsData.count
  },
  [FETCH_MERCHANT]: (state, merchant) => {
    state.merchant = merchant;
  },
  [DELETE_MERCHANT]: (state, merchantId) => {
    // remove merchant with id
  },

  [FETCH_MERCHANT_LOCATION]: (state, merchantLocation) => {
    state.merchantLocation = merchantLocation;
  },
  [FETCH_MERCHANT_LOCATIONS]: (state, merchantLocationsData) => {
    state.merchantLocations = [...merchantLocationsData.results]
    state.merchantLocationsCount = merchantLocationsData.count
  },
  [UPDATE_MERCHANT_LOCATION]: (state, locationUpdate) => {
    let index = state.merchantLocations.findIndex(merchant => merchant.id == locationUpdate.id);
    state.merchantLocations.splice(index, 1, locationUpdate)
  },
  [DELETE_MERCHANT_LOCATION]: (state, merchantLocationId) => {
  },

  [FETCH_TERMINAL]: (state, terminal) => {
    state.terminal = terminal;
  },
  [UPDATE_TERMINAL]: (state, terminalUpdate) => {
    const locationIndex = state.merchantLocations.findIndex(location => location.id == terminalUpdate.location);
    const index = state.merchantLocations[locationIndex].terminals
      .findIndex(terminal => terminal.id == terminalUpdate.id);
    state.merchantLocations[locationIndex].terminals.splice(index, 1, terminalUpdate)
  },
  [DELETE_TERMINAL]: (state, terminalId) => {
    // const index = state.merchantLocations[locationIndex].terminals
    //   .findIndex(terminal => terminal.id == terminalUpdate.id);
    // state.merchantLocations[locationIndex].terminals.splice(index, 1, terminalUpdate)
  },
}

const actions = {
  [CREATE_MERCHANT]: ({ commit, dispatch, rootState }, merchant) => {
    const body = JSON.stringify(merchant);
    return api.post(`/merchants/`, body).then((resp) => {
      commit(FETCH_MERCHANT, resp.data)
    }).catch(errorFn)
  },
  [FETCH_MERCHANT]: ({ commit, dispatch, rootState }, merchant_id) => {
    return api.get(`/merchants/${merchant_id}/`).then((resp) => {
      commit(FETCH_MERCHANT, resp.data)
    }).catch(errorFn)
  },
  [FETCH_MERCHANTS]: ({ commit }, query={
    page: null,
    updates: null,
    page_size: null,
    search: null
  }) => {
    let url = '/merchants/'

    return api.get(url, { params: {...query} }).then((resp) => {
      commit(FETCH_MERCHANTS, resp.data)
    }).catch(errorFn)
  },
  [UPDATE_MERCHANT]: ({ commit, dispatch, rootState }, merchant) => {
    const body = JSON.stringify(merchant);
    return api.patch(`/merchants/${merchant.id}/`, body).then((resp) => {
      commit(FETCH_MERCHANT, resp.data)
    }).catch(errorFn)
  },
  [DELETE_MERCHANT]: ({ commit, dispatch, rootState }, merchantId) => {
    return api.delete(`/merchants/${merchantId}/`).then((resp) => {
      commit(DELETE_MERCHANT, merchantId)
    }).catch(errorFn)
  },

  [CREATE_MERCHANT_LOCATION]: ({ commit }, merchantLocation) => {
    const body = JSON.stringify(merchantLocation);
    return api.post(`/merchant-locations/`, body).then((resp) => {
      commit(FETCH_MERCHANT_LOCATION, resp.data)
    }).catch(errorFn)
  },
  [FETCH_MERCHANT_LOCATIONS]: ({ commit }, query={
    marshal: null,
    updates: null,
    search: null,
    page: null,
    page_size: null
  }) => {
    let url = '/merchant-locations/'
    return api.get(url, { params: {...query} }).then((resp) => {
      commit(FETCH_MERCHANT_LOCATIONS, resp.data)
    }).catch(errorFn)
  },
  [UPDATE_MERCHANT_LOCATION]: ({ commit, dispatch, rootState }, merchantLocation) => {
    const body = JSON.stringify(merchantLocation);
    return api.patch(`/merchant-locations/${merchantLocation.id}/`, body).then((resp) => {
      commit(UPDATE_MERCHANT_LOCATION, resp.data)
    }).catch(errorFn)
  },
  [DELETE_MERCHANT_LOCATION]: ({ commit, dispatch, rootState }, merchantLocationId) => {
    return api.delete(`/merchant-locations/${merchantLocationId}/`).then((resp) => {
      commit(DELETE_MERCHANT_LOCATION, merchantLocationId)
    }).catch(errorFn)
  },

  [CREATE_TERMINAL]: ({ commit, dispatch, rootState }, terminal) => {
    const body = JSON.stringify(terminal);
    return api.post(`/terminals/`, body).then((resp) => {
      commit(FETCH_TERMINAL, resp.data)
    }).catch(errorFn)
  },
  [UPDATE_TERMINAL]: ({ commit, dispatch, rootState }, terminal) => {
    const body = JSON.stringify(terminal);
    return api.patch(`/terminals/${terminal.id}/`, body).then((resp) => {
      commit(UPDATE_TERMINAL, resp.data)
    }).catch(errorFn)
  },
  [DELETE_TERMINAL]: ({ commit, dispatch, rootState }, terminalId) => {
    return api.delete(`/terminals/${terminalId}/`).then((resp) => {
      commit(DELETE_TERMINAL, terminalId)
    }).catch(errorFn)
  },
}

export default {
  state, getters, mutations, actions
}